import { number } from "../../../value/types/numbers/index.js";
import { px, percent, degrees, vw, vh } from "../../../value/types/numbers/units.js";
import { testValueType } from "./test.js";
import { auto } from "./type-auto.js";
const dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto];
const findDimensionValueType = (v) => dimensionValueTypes.find(testValueType(v));
export {
  dimensionValueTypes,
  findDimensionValueType
};
//# sourceMappingURL=dimensions.js.map
